import React, {useEffect} from "react";
import {Route,Routes, NavLink, Navigate} 
from "react-router-dom";
import ProtectedRoute from "./routes/ProtectedRoute";
import OktaProtectedRoute from "./routes/OktaProtectedRoute";
import Home from "./pages/Home";
import Registration from "./pages/Registration";
import UserProfile from "./pages/Profile";
import Login from "./pages/Login";
import Warehouses from "./pages/warehouses/Warehouses";
import Inputs from "./pages/inputs/Inputs";
import Parameters from "./pages/parameters/Parameters";
import GeneralParams from "./pages/generalparams/GeneralParams";
import GeneralParamsRegions from "./pages/generalparams/GeneralParamsRegions";
import GeneralParamsSuppliers from "./pages/generalparams/GeneralParamsSuppliers";
import GeneralParamsWarehouses from "./pages/generalparams/GeneralParamsWarehouses";
import GeneralParamsContainers from "./pages/generalparams/GeneralParamsContainers";
import GeneralParamsContainersTypes from "./pages/generalparams/GeneralParamsContainersTypes";
import GeneralParamsApplications from "./pages/generalparams/GeneralParamsApplications";
import GeneralParamsProductsLabel from "./pages/generalparams/GeneralParamsProductsLabel";
import GeneralParamsItemsType from "./pages/generalparams/GeneralParamsItemsType";
import GeneralParamsCostGridLots from "./pages/generalparams/GeneralParamsCostGridLots";
import GeneralParamsCostGridSubTasks from "./pages/generalparams/GeneralParamsCostGridSubTasks";
import GeneralParamsCostGridUOM from "./pages/generalparams/GeneralParamsCostGridUOM";
import GeneralParamsCostGridFilter from "./pages/generalparams/GeneralParamsCostGridFilter";
import GeneralParamsCostGridTransfertsFilter from "./pages/generalparams/GeneralParamsCostGridTransfertsFilter";
import GeneralParamsPurchasesTypes from "./pages/generalparams/GeneralParamsPurchasesTypes";
import GeneralParamsFiscalYears from "./pages/generalparams/GeneralParamsFiscalYears";
import GeneralParamsPalletPoDelay from "./pages/generalparams/GeneralParamsPalletPoDelay";
import GeneralParamsTransfertPoDelay from "./pages/generalparams/GeneralParamsTransfertPoDelay";
import GeneralParamsUsers from "./pages/generalparams/GeneralParamsUsers";
import ParametersCountries from "./pages/parameters/ParametersCountries";
import ParametersCurrencies from "./pages/parameters/ParametersCurrencies";
import ParametersProductsPackagingPallets from "./pages/parameters/ParametersProductsPackagingPallets";
import ParametersKitsContent from "./pages/parameters/ParametersKitsContent";
import ParametersContainersContent from "./pages/parameters/ParametersContainersContent";
import InputsForecasts from "./pages/inputs/InputsForecasts";
import InputsCostsGrid from "./pages/inputs/InputsCostGrid";
import InputsCostsGridTransferts from "./pages/inputs/InputsCostGridTransferts";
import InputsProductPrice from "./pages/inputs/InputsProductPrice";
import InputsReturns from "./pages/inputs/InputsReturns";
import InputsBudgetPaidWarehouse from "./pages/inputs/InputsBudgetPaidWarehouse";
import InputsBudgetPaidYear from "./pages/inputs/InputsBudgetPaidYear";
import WarehousesInventories from "./pages/warehouses/WarehousesInventories";
import WarehousesInventoriesLeo from "./pages/warehouses/WarehousesInventoriesLeo";
import WarehousesDictionaryPartnumbersSapcodes from "./pages/warehouses/WarehousesDictionaryPartnumbersSapcodes";
import WarehousesPurchasesUpload from "./pages/warehouses/WarehousesPurchasesUpload";
import WarehousesOutbound from "./pages/warehouses/WarehousesOutbound";
import WarehousesInbound from "./pages/warehouses/WarehousesInbound";
import WarehousesStockProcurement from "./pages/warehouses/WarehousesStockProcurement";
import WarehousesStockReport from "./pages/warehouses/WarehousesStockReport";
import WarehousesPurchasesPoDealay from "./pages/warehouses/WarehousesPurchasesPoDealay";
import WarehousesTransfertsPoDealay from "./pages/warehouses/WarehousesTransfertsPoDealay";
import WarehousesTransferts from "./pages/warehouses/WarehousesTransferts";
import WarehousesBudget from "./pages/warehouses/WarehousesBudget";
import Dashboard from "./pages/dashboard/Dashboard";
import DashboardBudgetLogistics from "./pages/dashboard/DashboardBudgetLogistics";
import DashboardStock from "./pages/dashboard/DashboardStock";
import DashboardStockItems from "./pages/dashboard/DashboardStockItems";
import DashboardSupplierPurchasePlan from "./pages/dashboard/DashboardSupplierPurchasePlan";
import DashboardHistory from "./pages/dashboard/DashboardHistory";
import DashboardBudgetAnalysis from "./pages/dashboard/DashboardBudgetAnalysis";
import WeatherDaily from "./pages/weatherDaily";
import InputsForecastsAnalysis from "./pages/inputs/InputsForecastsAnalysis";
import './styles.css';
import {msalAsync, handleOktaCallback} from "./helpers/msal"
import { useNavigate, useLocation } from "react-router-dom";
import { useOktaAuth } from '@okta/okta-react';
import OktaLoginCallback from './components/OktaLoginCallback';

//import './node_modules/bootstrap/dist/css/bootstrap-theme.min.css';
//import 'bootstrap/dist/css/bootstrap.min.css';
//import 'bootstrap/dist/js/bootstrap.min.js';

// Component to handle root route - redirects based on auth state
function HomeRedirect() {
  const { authState } = useOktaAuth();
  const location = useLocation();
  const search = typeof window !== 'undefined' ? window.location.search : (location.search || '');
  const searchParams = new URLSearchParams(search);
  const isOAuthCallback = searchParams.has('code') && searchParams.has('state');

  if (isOAuthCallback) {
    return <OktaLoginCallback />;
  }

  // Wait for auth to be determined (null = still initializing, e.g. after refresh)
  if (authState === null) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // If authenticated, redirect to dashboard
  if (authState.isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // If not authenticated, show login
  return <Login />;
  // return <LoginOkta />;
}

function App() {
  const location = useLocation();
  const navigate = useNavigate();


 return (


   <Routes>
  <Route path="/" element={<HomeRedirect />} />
  {/* <Route path="/loginOkta" element={<LoginOkta />} /> */}
  <Route path="/login/" element={<Login />} />
  <Route path="/register/" element={<Registration />} />
  <Route path="/user-profile/" element={<OktaProtectedRoute><UserProfile/></OktaProtectedRoute>} />
  <Route path="/warehouses/*" element={<OktaProtectedRoute><Warehouses /></OktaProtectedRoute>} />
  <Route path="/inputs/*" element={<OktaProtectedRoute><Inputs /></OktaProtectedRoute>} />
  <Route path="/parameters/*" element={<OktaProtectedRoute><Parameters /></OktaProtectedRoute>} />
  <Route path="/generalparams/*" element={<OktaProtectedRoute><GeneralParams /></OktaProtectedRoute>} />
  <Route path="/generalparams/regions" element={<OktaProtectedRoute><GeneralParamsRegions /></OktaProtectedRoute>} />
  <Route path="/generalparams/suppliers" element={<OktaProtectedRoute><GeneralParamsSuppliers /></OktaProtectedRoute>} />
  <Route path="/generalparams/warehouses" element={<OktaProtectedRoute><GeneralParamsWarehouses /></OktaProtectedRoute>} />
  <Route path="/generalparams/containers" element={<OktaProtectedRoute><GeneralParamsContainers /></OktaProtectedRoute>} />
  <Route path="/generalparams/containers-type" element={<OktaProtectedRoute><GeneralParamsContainersTypes /></OktaProtectedRoute>} />
  <Route path="/generalparams/applications" element={<OktaProtectedRoute><GeneralParamsApplications /></OktaProtectedRoute>} />
  <Route path="/generalparams/products-label" element={<OktaProtectedRoute><GeneralParamsProductsLabel /></OktaProtectedRoute>} />
  <Route path="/generalparams/items-type" element={<OktaProtectedRoute><GeneralParamsItemsType /></OktaProtectedRoute>} />
  <Route path="/generalparams/costgrid-lots" element={<OktaProtectedRoute><GeneralParamsCostGridLots /></OktaProtectedRoute>} />
  <Route path="/generalparams/costgrid-subtasks" element={<OktaProtectedRoute><GeneralParamsCostGridSubTasks /></OktaProtectedRoute>} />
  <Route path="/generalparams/costgrid-uom" element={<OktaProtectedRoute><GeneralParamsCostGridUOM /></OktaProtectedRoute>} />
  <Route path="/generalparams/costgrid-filter" element={<OktaProtectedRoute><GeneralParamsCostGridFilter /></OktaProtectedRoute>} />
  <Route path="/generalparams/costgrid-transferts-filter" element={<OktaProtectedRoute><GeneralParamsCostGridTransfertsFilter /></OktaProtectedRoute>} />
  <Route path="/generalparams/purchases-type" element={<OktaProtectedRoute><GeneralParamsPurchasesTypes /></OktaProtectedRoute>} />
  <Route path="/generalparams/fiscal-years" element={<OktaProtectedRoute><GeneralParamsFiscalYears /></OktaProtectedRoute>} />
  <Route path="/generalparams/palletpodelay" element={<OktaProtectedRoute><GeneralParamsPalletPoDelay /></OktaProtectedRoute>} />
  <Route path="/generalparams/transfertpodelay" element={<OktaProtectedRoute><GeneralParamsTransfertPoDelay /></OktaProtectedRoute>} />
  <Route path="/generalparams/users" element={<OktaProtectedRoute><GeneralParamsUsers /></OktaProtectedRoute>} />
  <Route path="/parameters/params-countries" element={<OktaProtectedRoute><ParametersCountries /></OktaProtectedRoute>} />
  <Route path="/parameters/params-currencies" element={<OktaProtectedRoute><ParametersCurrencies /></OktaProtectedRoute>} />
  <Route path="/parameters/products-packaging-pallets" element={<OktaProtectedRoute><ParametersProductsPackagingPallets /></OktaProtectedRoute>} />
  <Route path="/parameters/kits-content" element={<OktaProtectedRoute><ParametersKitsContent /></OktaProtectedRoute>} />
  <Route path="/parameters/containers-content" element={<OktaProtectedRoute><ParametersContainersContent /></OktaProtectedRoute>} />
  <Route path="/inputs/forecasts" element={<OktaProtectedRoute><InputsForecasts /></OktaProtectedRoute>} />
  <Route path="/inputs/cost-grid" element={<OktaProtectedRoute><InputsCostsGrid /></OktaProtectedRoute>} />
  <Route path="/inputs/cost-grid-transferts" element={<OktaProtectedRoute><InputsCostsGridTransferts /></OktaProtectedRoute>} />
  <Route path="/inputs/products-price" element={<OktaProtectedRoute><InputsProductPrice /></OktaProtectedRoute>} />
  <Route path="/inputs/returns" element={<OktaProtectedRoute><InputsReturns /></OktaProtectedRoute>} />
  <Route path="/inputs/forecasts-analysis" element={<OktaProtectedRoute><InputsForecastsAnalysis /></OktaProtectedRoute>} />
  <Route path="/inputs/budget-paid-warehouse" element={<OktaProtectedRoute><InputsBudgetPaidWarehouse /></OktaProtectedRoute>} />
  <Route path="/inputs/budget-paid-year" element={<OktaProtectedRoute><InputsBudgetPaidYear /></OktaProtectedRoute>} />
  <Route path="/warehouses/inventories" element={<OktaProtectedRoute><WarehousesInventories /></OktaProtectedRoute>} />
  <Route path="/warehouses/inventories-leo" element={<OktaProtectedRoute><WarehousesInventoriesLeo /></OktaProtectedRoute>} />
  <Route path="/warehouses/dictionary-partnumbers-sapcodes" element={<OktaProtectedRoute><WarehousesDictionaryPartnumbersSapcodes /></OktaProtectedRoute>} />
  <Route path="/warehouses/purchases-upload" element={<OktaProtectedRoute><WarehousesPurchasesUpload /></OktaProtectedRoute>} />
  <Route path="/warehouses/outbound" element={<OktaProtectedRoute><WarehousesOutbound/></OktaProtectedRoute>} />
  <Route path="/warehouses/Inbound" element={<OktaProtectedRoute><WarehousesInbound/></OktaProtectedRoute>} />
  <Route path="/warehouses/stock-procurement" element={<OktaProtectedRoute><WarehousesStockProcurement/></OktaProtectedRoute>} />
  <Route path="/warehouses/stock-report" element={<OktaProtectedRoute><WarehousesStockReport/></OktaProtectedRoute>} />
  <Route path="/warehouses/purchases-podelay" element={<OktaProtectedRoute><WarehousesPurchasesPoDealay/></OktaProtectedRoute>} />
  <Route path="/warehouses/transferts-podelay" element={<OktaProtectedRoute><WarehousesTransfertsPoDealay/></OktaProtectedRoute>} />
  <Route path="/warehouses/transferts" element={<OktaProtectedRoute><WarehousesTransferts/></OktaProtectedRoute>} />
  <Route path="/warehouses/warehouse-budget" element={<OktaProtectedRoute><WarehousesBudget/></OktaProtectedRoute>} />
  <Route path="/dashboard/*" element={<OktaProtectedRoute><Dashboard /></OktaProtectedRoute>} />
  <Route path="/dashboard/budget-logistics" element={<OktaProtectedRoute><DashboardBudgetLogistics /></OktaProtectedRoute>} />
  <Route path="/dashboard/stock" element={<OktaProtectedRoute><DashboardStock /></OktaProtectedRoute>} />
  <Route path="/dashboard/stock-items" element={<OktaProtectedRoute><DashboardStockItems /></OktaProtectedRoute>} />
  <Route path="/dashboard/supplier-purchase-plan" element={<OktaProtectedRoute><DashboardSupplierPurchasePlan /></OktaProtectedRoute>} />
  <Route path="/dashboard/history" element={<OktaProtectedRoute><DashboardHistory /></OktaProtectedRoute>} />
  <Route path="/dashboard/budget-analysis" element={<OktaProtectedRoute><DashboardBudgetAnalysis /></OktaProtectedRoute>} />
  <Route path="/weather/daily" element={<OktaProtectedRoute><WeatherDaily /></OktaProtectedRoute>} />
</Routes>

 );
}
export default App;
